import { Button } from "@/components/ui/button";
import { Users, History } from "lucide-react";
import { SectionLabel } from "./shiftUi";
import { fmtLog } from "@/lib/tz";

export function ShiftApplications({ shift, can, onApprove }) {
  if (!(shift?.applications?.length > 0)) return null;
  return (
    <div>
      <SectionLabel><Users className="h-3 w-3 inline mr-1" />Job Board Applications</SectionLabel>
      <div className="space-y-1.5">
        {shift.applications.map((a, i) => (
          <div key={i} className="flex items-center justify-between rounded-md border border-slate-200 px-3 py-2" data-testid={`application-${a.support_worker}`}>
            <div>
              <div className="text-xs font-medium text-slate-800">{a.worker_name || a.support_worker}</div>
              <div className="text-[10px] text-slate-400">{a.status} · {fmtLog(a.applied_on)}{a.note ? ` · ${a.note}` : ""}</div>
            </div>
            {can.has("roster.job_board") && a.status === "Applied" && (
              <Button size="sm" className="h-7 text-[11px]" style={{ backgroundColor: "#bf3b4f" }}
                onClick={() => onApprove(a.support_worker)} data-testid={`approve-app-${a.support_worker}`}>
                Approve &amp; assign
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function ShiftAudit({ entries }) {
  if (!(entries?.length > 0)) return null;
  return (
    <div>
      <SectionLabel><History className="h-3 w-3 inline mr-1" />Audit Trail</SectionLabel>
      <div className="space-y-1 border-l-2 border-slate-100 pl-3">
        {[...entries].reverse().map((a, i) => (
          <div key={i} className="text-[11px] text-slate-600" data-testid="audit-entry">
            <span className="font-semibold text-slate-800">{a.action}</span>
            <span className="text-slate-400"> · {fmtLog(a.timestamp)} · {a.performed_by}</span>
            {a.reason && <div className="text-slate-500 italic">“{a.reason}”</div>}
            {a.details && <div className="text-slate-400">{a.details}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
